<template>
	<div class="filter-options">
		<div
			class="filter-options-group px-0 col-md-12" 
			v-for="(opt, index) in masAllOptions"
			:key="index"
			>
			<h6>{{ opt.blockTitle }}</h6>
			<template v-for="element in opt.elements">
				<template
					v-if="element.auto_hidden !== true || element.auto_show == true">
				<div class="row" v-if="element.elementType == 'input'" :data-element="element" :key="element.elementGetParamMap" :class="[{'d-none':(typeof element.hide != 'undefined' && element.hide===true)}]">
					<label class="col-form-label col-md-3">{{ element.label }}</label>
					<div class="col-md-9">
						<div class="form-group">
							<div class="mb-0">
								<input type="text" aria-describedby="addon-right addon-left" :placeholder="element.placeholder" class="form-control" v-model.lazy="element.element_model" @input="change(element)">
							</div>
						</div>
					</div>
				</div>

				<div class="row" v-if="element.elementType == 'input-number'" :data-element="element" :key="element.elementGetParamMap" :class="[{'d-none':(typeof element.hide != 'undefined' && element.hide===true)}]">
					<label class="col-form-label col-md-3">{{ element.label }}</label>
					<div class="col-md-9">
						<div class="form-group">
							<div class="mb-0">
								<input type="number" aria-describedby="addon-right addon-left" :placeholder="element.placeholder" class="form-control" v-model.lazy="element.element_model" @input="change(element)">
							</div>
						</div>
					</div>
				</div>

				<div class="row" v-if="element.elementType == 'input-amount'" :data-element="element" :key="element.elementGetParamMap" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
					<label class="col-form-label col-md-3" v-if="typeof element.label !='undefined' && element.label !=''" :class="[{'formRequired':element.required===true}]"> <span>{{ element.label }}</span></label>
					<div class="form-group col-md-9">
						<ReInputAmount 
							:findId="element.elementGetParamMap"
							:placeholder="element.placeholder"
							v-model="element.element_model"
							@input="change(element)" />
					</div>
				</div>

				<div class="row" v-if="element.elementType == 'checkbox-group'" :data-element="element" :key="element.elementGetParamMa" :class="[{'d-none':(typeof element.hide != 'undefined' && element.hide===true)}]">
					<label class="col-form-label col-md-3" v-if="typeof element.label !='undefined' && element.label !=''"><span>{{ element.label }}</span></label>
					<div class="col-md-9 checkbox-radios">
						<base-checkbox v-for="el_opt in element.options" 
						:checked="element.element_model[el_opt.key]" 
						v-model="element.element_model[el_opt.key]" 
						:disabled="typeof el_opt.disabled != 'undefined'? el_opt.disabled:false" 
						:key="el_opt.key" 
						inline
						@input="change(element)">{{el_opt.label}}</base-checkbox>
					</div>
				</div>

				<div class="row" v-if="element.elementType == 'checkbox'" :data-element="element" :key="element.elementGetParamMap"  :class="[{'d-none':(typeof element.hide != 'undefined' && element.hide===true)}]">
					<label class="col-form-label col-md-3">{{ element.placeholder }}</label>
					<div class="col-md-9 checkbox-radios">
						<base-checkbox :checked="element.element_model" v-model="element.element_model" inline @input="change(element)">{{element.label}}</base-checkbox>
					</div>
				</div>

				<div class="row" v-if="element.elementType == 'radio-group'" :data-element="element" :key="element.elementGetParamMap" :class="[{'d-none':(typeof element.hide != 'undefined' && element.hide===true)}]">
					<label class="col-form-label col-md-3">{{ element.label }}</label>
					<div class="col-md-9 checkbox-radios">
						<base-radio
							v-for="(el_opt, el_index) in element.options"
							:name="el_opt.name"
							v-model="element.element_model"
							inline
							:key="el_index"
							@input="change(element)"
						>{{el_opt.label}}</base-radio>
					</div>
				</div>

				<div class="row" v-if="element.elementType == 'select'" :data-element="element" :key="element.elementGetParamMap" :class="[{'d-none':(typeof element.hide != 'undefined' && element.hide===true)}]">
					<label class="col-form-label col-md-3">{{ element.label }}</label>
					<div class="col-md-9 d-flex" style="align-items: center;">
						<el-select
							class="w-100 select-primary "
							size="large"
							:placeholder="element.placeholder"
							v-model="element.element_model"
							:filterable="typeof element.filterable == 'undefined' ? false : element.filterable"
							:allow-create="typeof element['allow-create'] == 'undefined' ? false : element['allow-create']"
							:multiple="typeof element.multiple == 'undefined' ? false : element.multiple"
							:multiple-limit="typeof element.multiple_limit == 'undefined' ? 0 : element.multiple_limit"
							clearable
							@change="change(element)"
						>
							<el-option
								v-for="(el_opt, el_index) in element.options"
								class="select-primary"
								:value="String(el_opt.value)"
								:label="el_opt.label"
								:key="el_index"
								
							>{{el_opt.label}}
							</el-option>
						</el-select>
						<base-button v-if="element.required == false && (typeof element.multiple == 'undefined' ? true : !element.multiple)" type="danger" class="no-border my-0" simple icon @click="element.element_model = '';"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
					</div>
				</div>

				<div class="row" v-if="element.elementType == 'select-tree'" :data-element="element" :key="element.elementGetParamMap" :class="[{'d-none':(typeof element.hide != 'undefined' && element.hide===true)}]">
					<label class="col-form-label col-md-3">{{ element.label }}</label>
					<div class="col-md-9 d-flex" style="align-items: center;">
						<ReTreeSearchDrop 
							class="select-primary w-100"
							:name="element.elementGetParamMap"
							:placeholder="element.placeholder"
							v-model="element.element_model"
							@input="change(element)"
						/>
						<base-button type="danger" class="no-border my-0" simple icon @click="element.element_model.inputText = '';element.element_model.selectedVal = '';"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
					</div>
				</div>

				<div class="row" v-if="element.elementType == 'input-date-range'" :data-element="element" :key="element.elementGetParamMap" :class="[{'d-none':(typeof element.hide != 'undefined' && element.hide===true)}]">
					<label class="col-form-label col-md-3">{{ element.label }}</label>
					<div class="form-group col-md-9">
						<ReDateRange 
							:range_separator="element.range_separator"
							:start_placeholder="element.start_placeholder"
							:end_placeholder="element.end_placeholder"
							v-model="element.element_model"
							@input="change(element)"
						/>
					</div>
				</div>

				<div class="row" v-if="element.elementType == 'input-date'" :data-element="element" :key="element.elementGetParamMap" :class="[{'d-none':(typeof element.hide != 'undefined' && element.hide===true)}]">
					<label class="col-form-label col-md-3">{{ element.label }}</label>
					<div class="form-group col-md-9">
						<el-date-picker
								type="date"
								format="dd.MM.yyyy"
								value-format="yyyy-MM-dd"
								:placeholder="element.placeholder"
								v-model="element.element_model"
								@input="change(element)"
						>
						</el-date-picker>
					</div>
				</div>

				<div class="row" v-if="element.elementType == 'input-datetime'" :data-element="element" :key="element.elementGetParamMap" :class="[{'d-none':(typeof element.hide != 'undefined' && element.hide===true)}]">
					<label class="col-form-label col-md-3">{{ element.label }}</label>
					<div class="form-group col-md-9">
						<el-date-picker
								type="datetime"
								format="dd.MM.yyyy HH:mm:ss"
								value-format="yyyy-MM-dd HH:mm:ss"
								:placeholder="element.placeholder"
								v-model="element.element_model"
								@input="change(element)"
						>
						</el-date-picker>
					</div>
				</div>

				<div class="row" v-if="element.elementType == 'input-time'" :data-element="element" :key="element.elementGetParamMap" :class="[{'d-none':(typeof element.hide != 'undefined' && element.hide===true)}]">
					<label class="col-form-label col-md-3">{{ element.label }}</label>
					<div class="form-group col-md-9">
						<base-input>
							<el-time-select 
								:placeholder="element.placeholder" 
								v-model="element.element_model"
								@input="change(element)"
							>
							</el-time-select>
						</base-input>
					</div>
				</div>

				<div class="row" v-if="element.elementType == 'input-time-range'" :data-element="element" :key="element.elementGetParamMap" :class="[{'d-none':(typeof element.hide != 'undefined' && element.hide===true)}]">
					<label class="col-form-label col-md-3">{{ element.label }}</label>
					<div class="form-group col-md-9">
						<ReTimeRange 
							:range_separator="element.range_separator"
							:start_placeholder="element.start_placeholder"
							:end_placeholder="element.end_placeholder"
							v-model="element.element_model"
							@input="change(element)"
						/>
					</div>
				</div>

				<div class="row" v-if="element.elementType == 'switcher'" :data-element="element" :key="element.elementGetParamMap" :class="[{'d-none':(typeof element.hide != 'undefined' && element.hide===true)}]">
					<label class="col-form-label col-md-3">{{ element.placeholder }}</label>
					<div class="form-group col-md-9">
						<base-switch
							v-model="element.element_model"
							type="primary"
							:on-text="element.label_on"
							:off-text="element.label_off"
							@change="change(element)"
						></base-switch>
					</div>
				</div>

				<div class="row" v-if="element.elementType == 'ajax-list'" :data-element="element" :key="element.elementGetParamMap" :class="[{'d-none':(typeof element.hide != 'undefined' && element.hide===true)}]">
					<label class="col-form-label col-md-3">{{ element.label }}</label>
					<!--
					<div class="form-group col-md-9">
						<ReInputSearchDrop 
							:findId="element.elementGetParamMap"
							:name="element.name"
							:placeholder="element.placeholder"
							v-model="element.element_model"
							:objApiMethod="element.objApiMethod"
							:strApiMethodKey="element.strApiMethodKey"
							:strType="element.strType"
							v-on:change="OnAjaxListSearch"
						/>
					</div>
					-->
					<div class="col-md-9 d-flex" style="align-items: center;">
						<ReInputSearchDrop 
							class="w-100"
							:findId="element.elementGetParamMap"
							:name="element.name"
							:placeholder="element.placeholder"
							v-model="element.element_model"
							:objApiMethod="element.objApiMethod"
							:strApiMethodKey="element.strApiMethodKey"
							:strType="element.strType"
							v-on:change="OnAjaxListSearch"
							@input="change(element)"
						/>
						<base-button type="danger" class="no-border my-0" simple icon @click="element.element_model = {'inputText':'','selectedVal':''};"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
					</div>
				</div>

				<div class="row" v-if="element.elementType == 'ajax-list-type'" :data-element="element" :key="element.elementGetParamMap" :class="[{'d-none':(typeof element.hide != 'undefined' && element.hide===true)}]">
					<label class="col-form-label col-md-3">{{ element.label }}</label>
					<div class="form-group col-md-9">
						<ReInputSearchDropType 
							:MinTxtLen="element.mintxtlen"
							:findId="element.elementGetParamMap"
							:name="element.name"
							:placeholder="element.placeholder"
							v-model="element.element_model"
							:objApiMethod="element.objApiMethod"
							:strApiMethodKey="element.strApiMethodKey"
							:strType="element.strType"
							v-on:change="OnAjaxListSearch"
							@input="change(element)"
						/>
					</div>
				</div>

				<div class="row" v-if="element.elementType == 'ajax-list-task_staff'" :data-element="element" :key="element.elementGetParamMap" :class="[{'d-none':(typeof element.hide != 'undefined' && element.hide===true)}]">
					<label class="col-form-label col-md-3">{{ element.label }}</label>
					<div class="form-group col-md-9">
						<ReSearchTaskStaff 
							:findId="element.elementGetParamMap"
							:name="element.name"
							:placeholder="element.placeholder"
							v-model="element.element_model"
							:objApiMethod="element.objApiMethod"
							:strApiMethodKey="element.strApiMethodKey"
							:strType="element.strType"
							v-on:change="OnAjaxListSearch"
							@input="change(element)"
						/>
					</div>
				</div>

				<div class="row" v-if="element.elementType == 'select-cascade-services'" :data-element="element" :key="element.elementGetParamMap" :class="[{'d-none':(typeof element.hide != 'undefined' && element.hide===true)}]">
					<label class="col-form-label col-md-3">{{ element.label }}</label>
					<div class="form-group col-md-9">
						<ReSelectCascadeServices 
							:findId="element.elementGetParamMap"
							v-model="element.element_model" 
							:hide_rb_service="element.hide_rb_service"
							:rb_readonly="element.rb_readonly"
							:stage_hide="element.stage_hide"
							:multi_service="element.multi_service"
							@change="change(element)"
							/>
					</div>
				</div>

				<div class="row" v-if="element.elementType == 'select-cascade'" :data-element="element" :key="element.elementGetParamMap" 
				:class="[{'d-none':(typeof element.hide != 'undefined' && element.hide===true)}]">
					<label class="col-form-label col-md-3">{{ element.label }}</label>
					<div class="form-group col-md-9">
						<ReSelectCascade 
							:findId="element.elementGetParamMap"
							v-model="element.element_model" 
							@change="change(element)"
							/>
					</div>
				</div>

				<div class="row" v-if="element.elementType == 'ajax-list-client'" :data-element="element" :key="element.elementGetParamMap">
					<label class="col-form-label col-md-3">{{ element.label }}</label>
					<div class="form-group col-md-9">
						<ReSearchStaffClients 
							:findId="element.elementGetParamMap"
							:name="element.name"
							:placeholder="element.placeholder"
							:placeholder_otdel="element.placeholder_otdel"
							v-model="element.element_model"
							:objApiMethod="element.objApiMethod"
							:strApiMethodKey="element.strApiMethodKey"
							:objApiMethod_otdel="element.objApiMethod_otdel"
							:strApiMethodKey_otdel="element.strApiMethodKey_otdel"
							:rb_options="element.rb_options"
							:hide_staffsearch="element.hide_staffsearch"
							v-on:change="OnAjaxListSearch"
							@input="change(element)"
						/>
					</div>
				</div>

				<div class="row" v-if="element.elementType == 'date-range-strange'" :data-element="element" :key="element.elementGetParamMap" :class="[{'d-none':(typeof element.hide != 'undefined' && element.hide===true)}]">
					<label class="col-form-label col-md-3">{{ element.label }}</label>
					<div class="form-group col-md-9">
						<ReStrangeDateRange 
							:findId="element.elementGetParamMap"
							:name="element.name"
							:placeholder="element.placeholder"
							:noDetail = "element.noDetail"
							v-model="element.element_model"
							@input="change(element)"
						/>
					</div>
				</div>

				<div class="row" v-if="element.elementType == 'input-range'" :data-element="element" :key="element.elementGetParamMap" :class="[{'d-none':(typeof element.hide != 'undefined' && element.hide===true)}]">
					<label class="col-form-label col-md-3">{{ element.label }}</label>
					<div class="form-group col-md-9">
						<ReInputRange 
							:findId="element.elementGetParamMap"
							:placeholder="element.placeholder"
							:inputType="element.type"
							v-model="element.element_model"
							@input="change(element)"
						/>
					</div>
				</div>

				<div class="row" v-if="element.elementType == 'select-objcat'" :data-element="element" :key="element.elementGetParamMap" :ref="element.elementGetParamMap" :id="element.elementGetParamMap" :class="[{'d-none':(typeof element.hide != 'undefined' && element.hide===true)}]">
					<label class="col-form-label col-md-3">{{ element.label }}</label>
					<div class="form-group col-md-9">
						<ReSelectCascadeObjCategory
							:findId="element.elementGetParamMap"
							v-model="element.element_model"
							@change="change(element)"
						/>
					</div>
				</div>

				<div class="row" v-if="element.elementType == 'district-picker'" :data-element="element" :key="element.elementGetParamMap" :ref="element.elementGetParamMap" :id="element.elementGetParamMap" :class="[{'d-none':(typeof element.hide != 'undefined' && element.hide===true)}]">
					<label class="col-form-label col-md-3">{{ element.label }}</label>
					<div class="form-group col-md-9">
						<ReDistrictPicker
							:findId="element.elementGetParamMap"
							v-model="element.element_model"
							@input="change(element)"
						/>
					</div>
				</div>

				<div class="row" v-if="element.elementType == 'district-multi-picker'" :data-element="element" :key="element.elementGetParamMap" :ref="element.elementGetParamMap" :id="element.elementGetParamMap" :class="[{'d-none':(typeof element.hide != 'undefined' && element.hide===true)}]">
					<label class="col-form-label col-md-3">{{ element.label }}</label>
					<div class="form-group col-md-9">
						<ReDistrictMultiPicker
							:findId="element.elementGetParamMap"
							v-model="element.element_model"
							:regions="element.regions"
							@input="change(element)"
						/>
					</div>
				</div>


				<div class="row" v-if="element.elementType == 'ajax-list-tags' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
					<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''"> <span>{{ element.label }}</span></label>
					<div class="form-group col-md-12">
						<ReTagGroupList
							v-model="element.element_model"
							:name="element.name"
							:findId="element.elementGetParamMap"
							:placeholder="element.placeholder"
							:objApiMethod="element.objApiMethod"
							:strApiMethodKey="element.strApiMethodKey"
							:strType="element.strType"
						/>
					</div>
				</div>

				<div class="row" v-if="element.elementType == 'input-mask' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap" :data-element="element" :class="[{'d-none':(typeof element.hide != 'undefined' && element.hide===true)}]">
					<label class="col-form-label col-md-3" v-if="typeof element.label !='undefined' && element.label !=''"> <span>{{ element.label }}</span></label>
					
					<div class="form-group col-md-9">
						<div class="mb-0">
							<ReInputMask :mask="element.mask" :findId="element.elementGetParamMap" :placeholder="element.placeholder" v-model="element.element_model" :required="$GVO.toBool(element.required)"/>
						</div>
					</div>
					
				</div>
				<div class="row" v-if="element.elementType == 'input-ajaxsearch-distrmetro' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap" :data-element="element" :class="[{'d-none':(typeof element.hide != 'undefined' && element.hide===true)}]" >
					<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''"> <span>{{ element.label }}</span></label>
					<div class="form-group col-md-12">
						<ReInputSearchDistrMetro 
							:findId="element.elementGetParamMap"
							:placeholder="element.placeholder"
							v-model="element.element_model"
							@input="change(element)"/>
					</div>
				</div>

				<div class="row" v-if="element.elementType == 'HELP'" :data-element="element" :key="element.elementGetParamMap">
				<pre>
					Описание ПРОПСов для FilterPrinter:
						- masAllFilterParams			[Array]		Массив объектов описания полей
						- value					[Object]	это v-model сомпонента
							Формат выходных данных {key1: value1, key2: value2,}
					FilterPrinter возвращает объект с параметрами для добавления в фильтр и GET строку

					Имеет события на ружу:
						1) input - для v-model, возвращает value
						2) filterapply - чтобы можно было вызвать функцию срабатывания на изменения в фильтре, возвращает value

					Имеет события которые сам слушает:
						1) OnFilterConfigLoad - НАДО ВЫЗЫВАТЬ КОГДА ПОЛУЧИЛИ КОНФИГ. т.к. конфиг загружается асинхронно, то при создании фильтра его может не быть.
						2) ResetFilter - Фильтр сбрасывает все значения на по-умолчанию

					Как устроены Collapse-ы:
						Тут Collapse-ов НЕТ!

					Обязательные свойства при описании поля:
						elementGetParamMap:	[String] 		Название параметры которое будет передано в АПИ
						element_model: 		[Что угодно] 		Входные/выходные данные компонента
						element_model_default:	[Что угодно]		Необходимо для сброса параметров фильтра на первоначальные. ЗНАЧЕНИЕМ ДОЛЖНО СОВПАДАТЬ С element_model
						elementType: 		[String] 		Тип поля для отрисовке в интерфейсе

					Не обязательные свойства:
						elementID:		[String] 		Зарезервировано непонятно для чего, но зарезервировано
						elementCat:		[String] 		Название справочника, например для выпадающего списка в селекте
						label:			[String] 		Заголовок для компонента/поля
						placeholder:		[String] 		Placeholder для компонента/поля
						*options:		[Array]			Массив объектов для отрисовки выпадающего списка или группы переключателей, формат может быть разным
							для Селектов:		[{value: '1', label: 'Да',},{value: '0', label: 'Нет',}]
							для переключателей:	[{name: '1', label: 'Да',},{name: '0', label: 'Нет',}]

					Все выходные параметры:
						v-model поля в element_model

					Типы полей:
						1) checkbox-group
							- Группа галочек
							- Входные параметры:
								elementGetParamMap	[String]	Перечисление всех имен параметров через разделитель, например 'vm_fst|vm_snd|vm_trd'
								label			[String]	Текст для группы, левый лейбл
								element_model		[Object]	Немного сложно, НО: имя свойства это ключ в options
									такого формата {vm_fst:false,vm_snd:true,vm_trd:false}
								options	[Array]
									такого формата [{key:'vm_fst',label:'первый'},{key:'vm_snd',label:'второй'},{key:'vm_trd',label:'третий',disabled:true},]
										key		[String]	связь со свойством в element_model, а так же значение параметра для фильтра и АПИ запроса
										label		[String]	Надпись у галочки
										disabled	[Boolean]	Отклюяает взаимодействие с галочкой. Если не передавать равен false.
						2) checkbox
							- Одиночная галочка
							- Входные параметры:
								placeholder	[String]	ОСОБЕННОСТЬ: Это левый лэйбл для галочки
								label		[String]	Это основной лейбл галочки
								element_model	[Boolean]	Оно же идёт в checked
						3) input
							- Поле ввода
							- Входные параметры:
								label
								placeholder
								element_model	[String]||[Number]
						4) radio-group
							- Группа переключателей
							- Входные параметры:
								label
								element_model	[String]||[Number]
								options		[Array]
									такого формата [{name: '1', label: 'Да',},{name: '0', label: 'Нет',}]
						5) select
							- Список выбора параметров
							- Входные параметры:
								element_model 	[String]||[Array]	фиксация выбора, [Array] когда multiselect=true
								filterable	[Boolean]		Параметр позволяет осуществлять поиск по опциям
								multiple	[Boolean]		Параметр позволяет выбрать более одного значения
								options		[Array]
									такого формата [{value: '1', label: 'Да',},{value: '0', label: 'Нет',}]
						6) select-tree
							- Список выбора параметров для древовидных структур, например: структура организации
							- Входные параметры:
								element_model	[Array]	
									такого формата ['inputText':'', 'selectedVal':'']
						7) input-date-range
							- Выбор даты промежутком От - До. Отображаемый формат dd.MM.yyyy
							- Входные параметры:
								elementGetParamMap	[String]	ОСОБЕННОСТЬ: оба поля через разделитель вот так ПАРАМЕТР_ОТ|ПАРАМЕТР_ДО, например: 'sds|sde'
								range_separator		[String]	Символ между полями дат
								start_placeholder	[String]	placeholder для первого поля От
								end_placeholder		[String]	placeholder для второго поля До
								element_model		[Array]
									такого формата ['startDt':'','endDt':'']
						8) input-date
							- Выбор даты. Отображаемый формат dd.MM.yyyy
							- Входные параметры:
								element_model	[String]	Дата
						9) input-datetime
							- Выбор даты и времени. Отображаемый формат dd.MM.yyyy HH:mm:ss
							- Входные параметры:
								element_model	[String]	Дата время, в формате yyyy-MM-dd HH:mm:ss
						10) input-time
							- Выбор даты и времени. Отображаемый формат HH:mm
							- Входные параметры:
								element_model	[String]	Дата время, в формате HH:mm:ss
						11) input-time-range
							- Выбор времени промежутком От - До. Отображаемый формат HH:mm
							- Входные параметры:
								elementGetParamMap	[String]	ОСОБЕННОСТЬ: оба поля через разделитель вот так ПАРАМЕТР_ОТ|ПАРАМЕТР_ДО, например: 'sts|ste'
								range_separator		[String]	Символ между полями времени
								start_placeholder	[String]	placeholder для первого поля От
								end_placeholder		[String]	placeholder для второго поля До
								element_model		[Array]
									такого формата ['startDt':'','endDt':'']
						12) switcher
							- Переключатель типа On/Off
							- Входные параметры:
								element_model	[Boolean]
						13) district-multi-picker
							- Множественный выбор районов
							- Входные параметры
								element_model - Array
								regions - Array кодов регионов, где надо применить
				</pre>
			</div>
			</template>
			</template>
		</div>
	</div>
</template>

<script>
	import { TimeSelect, DatePicker, Select, Option } from 'element-ui';
	import { BaseCheckbox, BaseRadio, BaseSwitch } from 'src/components/index';
	import ReTreeSearchDrop from 'src/our_components/ReTreeSearchDrop.vue';
	import ReDateRange from 'src/our_components/ReDateRange.vue';
	import ReTimeRange from 'src/our_components/ReTimeRange.vue';
	import ReInputSearchDrop from 'src/our_components/ReInputSearchDrop.vue';
	import ReSearchTaskStaff from 'src/our_components/ReSearchTaskStaff.vue';
	import ReSelectCascadeServices from 'src/our_components/ReSelectCascadeServices.vue';
	import ReSearchStaffClients from 'src/our_components/ReSearchStaffClients.vue';
	import ReStrangeDateRange from 'src/our_components/ReStrangeDateRange.vue';
	import ReInputSearchDropType from 'src/our_modules/SearchSendObjects/ReInputSearchDropType.vue';
	import ReInputRange from 'src/our_components/ReInputRange.vue';
	import ReSelectCascadeObjCategory from 'src/our_components/ReSelectCascadeObjCategory.vue';
	import ReTagGroupList from "src/our_components/ReTagGroupList.vue";
	import ReInputAmount from 'src/our_components/ReInputAmount.vue';
	import ReInputMask from 'src/our_components/ReInputMask.vue';
	import ReInputSearchDistrMetro from 'src/our_components/ReInputSearchDistrMetro.vue';
	import ReDistrictPicker from 'src/our_components/ReDistrictPicker.vue';
	import ReSelectCascade from 'src/our_components/ReSelectCascade.vue';
	import ReDistrictMultiPicker from 'src/our_components/ReDistrictMultiPicker.vue'


	export default {
		name: 'ReFilterOptions',
		components: {
			[DatePicker.name]: DatePicker,
			[TimeSelect.name]: TimeSelect,
			[Option.name]: Option,
			[Select.name]: Select,
			BaseCheckbox,
			BaseRadio,
			ReTreeSearchDrop,
			ReDateRange,
			ReTimeRange,
			BaseSwitch,
			ReInputSearchDrop,
			ReSearchTaskStaff,
			ReSelectCascadeServices,
			ReSearchStaffClients,
			ReStrangeDateRange,
			ReInputSearchDropType,
			ReInputRange,
			ReSelectCascadeObjCategory,
			ReTagGroupList,
			ReInputAmount,
			ReInputMask,
			ReInputSearchDistrMetro,
			ReDistrictPicker,
			ReDistrictMultiPicker,
			ReSelectCascade,
		},
		props: {
			masAllOptions: Array,
			// opt: Object
		},
		data () {
			return {
				ver: 1,
			}
		},
		methods: {
			OnAjaxListSearch(opt){

			},
			ClearSelect(el_model){
				el_model = '';
			},
			changeVisible(list, status){
				if(list && list.length){
					// console.log(this.masAllOptions)
					this.masAllOptions.forEach(opt=>{opt.elements.forEach(el=>{
							// console.log(el.elementGetParamMap)
							if(list.indexOf(el.elementGetParamMap)>-1)
								// console.log('hide',el.elementGetParamMap,status)
								if(el.auto_show != status){
									el.auto_show=status
									this.changeVisible(el.old_show, status)
								}
						})
					})
				}

			},			
			change(element){
				this.$emit('value-change',{element});
				// console.log('change',element && element.elementGetParamMap, element)
				if(element.show_fields){
					// Получаем из вида 1:field1,field2,2:field3,field4 массив поиска
					// v[0] - это значение до :, совпадающее с выбранным значением в компоненте element_model
					// console.log(element.show_fields);
					const element_model=String(element.element_model); // Сделаем строкой для логических значений
					const tmp=element.show_fields.split(';').map(v=>v.split(':')).find(v=>v[0]==element_model);
					this.changeVisible(element.old_show, false)
					element.old_show=[];
					if(tmp && tmp[1]){
						element.old_show=tmp[1].split(',')
					}
					this.changeVisible(element.old_show, true);
					/*
					if(element.old_show.length>0){
						this.opt.elements.forEach(el=>{
							if(element.old_show.indexOf(el.elementGetParamMap)>-1){
								//console.log('show',el.elementGetParamMap)
								el.auto_show=true
							}
						})
					}
					*/
					//console.log('element', element, element.old_show);
				}				
			},
		},
		mounted(){
			try{
				this.masAllOptions[0].elements.map(el=>this.change(el))
			}catch(e){}
			//this.change(this);
		},
	}
</script>
<style scoped>
	.filter-options > *{display: inline-block;}
	/*.filter-param-group > *{display: inline-block; margin-right: 10px; margin-bottom: 10px;}*/
	.row {margin-bottom: 10px;}

</style>
